import { useUserStore } from "@/modules/auth/store/user";
import { RANK_CODES } from "@/modules/user/types/wallet";
import { useTranslation } from "react-i18next";
import Cell from "./Cell";
import { Icon } from "@/components/common/icon/Icon";
import Skeleton from "@/components/common/Skeleton";

const Rank = () => {
  const { t } = useTranslation();

  const { matchingBonus, isMatchingBonusLoading } = useUserStore();

  const currentCode = matchingBonus.rank.current.code;
  const nextCode = matchingBonus.rank.next.code;

  const currentIndex = RANK_CODES.indexOf(currentCode);
  const nextIndex = RANK_CODES.indexOf(nextCode);

  const lockedRanks = RANK_CODES.slice(nextIndex);

  if (isMatchingBonusLoading)
    return Array.from({ length: 4 }).map((_, i) => (
      <div key={i} className="w-full flex flex-col bg-bg rounded-[0.75rem]">
        <div className="w-full flex items-center gap-4 px-4 py-2">
          <div className="shrink-0 w-7 h-7 flex items-center justify-center">
            <Icon type="lock" className="shrink-0 fill-link w-5 h-5" />
          </div>

          <div className="flex-1 flex flex-col gap-0.5 py-3">
            <Skeleton className="w-25 h-5.5" />
            <Skeleton className="w-20 h-4" />
          </div>
        </div>
      </div>
    ));

  return (
    <>
      <div className="w-full flex flex-col bg-bg rounded-[0.75rem]">
        <Cell
          iconType="check-fill"
          title={`${t("bonus-page.rank")} ${currentIndex + 1}: ${
            matchingBonus.rank.current.title
          }`}
          description={`${t("bonus-page.condition")}: ${t(
            `bonus-page.ranks.${currentCode}.description`
          )}`}
        />
      </div>

      {lockedRanks.map((code, index) => (
        <div
          key={code}
          className="w-full flex flex-col bg-bg rounded-[0.75rem]"
        >
          <Cell
            iconType="lock"
            title={`${t("bonus-page.rank")} ${nextIndex + index + 1}: ${t(
              `bonus-page.ranks.${code}.title`
            )}`}
            description={`${t("bonus-page.condition")}: ${t(
              `bonus-page.ranks.${code}.description`
            )}`}
          />
        </div>
      ))}
    </>
  );
};

export default Rank;
